import { Autocomplete, TextField } from '@mui/material'
import React from 'react'
import { Controller } from 'react-hook-form'

const ControllerAutocomplete = ({
  control, label, name, required = true, options = [], getOptionLabel = 'name',
  defaultValue = null, onChange = () => {}
}) => {

  return (
    <Controller
      rules={{ required }}
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({ field, fieldState: {error} }) => (
        <Autocomplete
          {...field}
          id={name}
          options={options}
          getOptionLabel={(option) => option[getOptionLabel] ?? ''}
          onChange={(_, value) => {
            field.onChange(value);
            onChange(value)
          }}
          renderInput={(params) =>
            <TextField
              {...params}
              error={error}
              label={label}
            />
          }
        />
      )}
    />
  )
}

export default ControllerAutocomplete
